module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_03-3de8e33cf7b16ebd8a2cc90775fcbc56.png";